import * as React from "react";
const SvgFiRrCatHead = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cat-head_svg__a)">
      <path
        fill="#062147"
        d="M7.5 12a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 7.5 12m1.499 7c-.067.007.065 0 0 0m6.002 0c-.065 0 .068.003 0 0M24 13.502C24 19.291 19.29 24 13.5 24h-2.933C4.741 24 0 19.289 0 13.499c0-5.296.41-9.104.767-11.83.1-.757.615-1.364 1.344-1.585a1.9 1.9 0 0 1 2.008.574L5.83 2.399a.64.64 0 0 0 .753.103c1.79-.938 3.708-1.471 5.399-1.502 1.778-.032 3.651.476 5.442 1.468a.635.635 0 0 0 .77-.094L19.893.64c.473-.538 1.243-.758 1.98-.528.73.227 1.242.839 1.334 1.599.315 2.581.792 6.499.792 11.792zm-2 0c0-5.171-.455-8.903-.763-11.434l-1.615 1.706a2.65 2.65 0 0 1-3.167.443c-1.484-.823-3.016-1.253-4.437-1.218-1.367.024-3.01.489-4.508 1.273a2.62 2.62 0 0 1-3.107-.474L2.729 2.093C2.385 4.746 2 8.423 2 13.497c0 4.688 3.844 8.501 8.567 8.501H13.5c4.687 0 8.5-3.812 8.5-8.498zm-6.803 3.518c-1.4-.282-1.902-1.431-2.086-2.23.902-.363 1.389-1.118 1.389-1.602 0-.656-.889-1.188-2.5-1.188s-2.5.532-2.5 1.188c0 .485.49 1.243 1.396 1.605-.179.797-.676 1.942-2.093 2.227A1 1 0 0 0 8.999 19c1.411-.154 2.414-1.019 3.001-1.869.587.85 1.436 1.792 3.001 1.869a.999.999 0 0 0 .196-1.98M16.5 9a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 16.5 9"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cat-head_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCatHead;
